export const trackEvent = (name, params = {}) => {
  if (window.gtag) window.gtag('event', name, params);
  if (window.dataLayer) window.dataLayer.push({ event: name, ...params });
};
